// extracted by mini-css-extract-plugin
module.exports = {"annotationBox":"style-module__annotationBox___2fIr6","active":"style-module__active___pu_i6","numberLabel":"style-module__numberLabel___2XM_g"};